import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import "./providers/i18n";

import AppProvider from "./providers/app";
import Loader from "./pages/Loader";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import AppLayout from "./layouts/App";
import PublicLayout from "./layouts/Public";
import AuthLayout from "./layouts/Auth";
import axios from "axios";
import { API_ROOT } from "./defines";
import "react-tabs/style/react-tabs.css";
// User
import UserList from "./user/List";
import UserForm from "./user/Form";

import ConstsList from "./consts/List";
import ConstsForm from "./consts/Form";

import PriceList from "./price/List";
import PriceForm from "./price/Form";

import SignList from "./sign/List";
import SignForm from "./sign/Form";

import OrderList from "./order/List";
import OrderForm from "./order/Form";

import TypeList from "./type/List";
import TypeForm from "./type/Form";

import AdviceList from "./advice/List";
import AdviceForm from "./advice/Form";

import Advice from "./pages/advice";
import AdviceDetail from "./pages/advice/detail";

import Log from "./log";
import LogDetail from "./log/detail";

import Home from "./pages/Home";
import Search from "./pages/Search";
import Type from "./pages/Type";
import Detail from "./pages/Detail";
import Basket from "./pages/Basket";
import Custom from "./pages/Custom";

axios.defaults.baseURL = API_ROOT;
document.addEventListener("wheel", function () {
  if (document.activeElement.type === "number") {
    document.activeElement.blur();
  }
});

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Suspense fallback={<Loader />}>
        <AppProvider>
          <div className="h-full w-full flex">
            <Routes>
              <Route path="/" element={<Navigate to="/order/home" />} />
              <Route path="/admin" element={<Navigate to="/auth/login" />} />
              <Route path="order" element={<PublicLayout />}>
                <Route path="home" element={<Home />} />
                <Route path="search/:text" element={<Search />} />
                <Route path="basket" element={<Basket />} />
                <Route path="advice" element={<Advice />} />
                <Route path="advice/view/:id" element={<AdviceDetail />} />
                <Route path="custom" element={<Custom />} />
                <Route path="type/:id" element={<Type />} />
                <Route path="detail/:id" element={<Detail />} />
              </Route>
              <Route path="auth" element={<AuthLayout />}>
                <Route path="login" element={<Login />} />
                <Route path="logout" element={<Login from="inside" />} />
              </Route>
              <Route path="app" element={<AppLayout />}>
                <Route path="log" element={<Log />} />
                <Route path="log/view/:id" element={<LogDetail />} />

                <Route path="user" element={<UserList />} />
                <Route path="user/new" element={<UserForm />} />
                <Route path="user/view/:id" element={<UserForm />} />

                <Route path="consts" element={<ConstsList />} />
                <Route path="consts/new" element={<ConstsForm />} />
                <Route path="consts/view/:id" element={<ConstsForm />} />

                <Route path="type" element={<TypeList />} />
                <Route path="type/new" element={<TypeForm />} />
                <Route path="type/view/:id" element={<TypeForm />} />

                <Route path="price" element={<PriceList />} />
                <Route path="price/new" element={<PriceForm />} />
                <Route path="price/view/:id" element={<PriceForm />} />

                <Route path="advice" element={<AdviceList />} />
                <Route path="advice/new" element={<AdviceForm />} />
                <Route path="advice/view/:id" element={<AdviceForm />} />

                <Route path="sign" element={<SignList />} />
                <Route path="sign/new" element={<SignForm />} />
                <Route path="sign/view/:id" element={<SignForm />} />

                <Route path="order" element={<OrderList />} />
                <Route path="order/new" element={<OrderForm />} />
                <Route path="order/view/:id" element={<OrderForm />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </AppProvider>
      </Suspense>
    </React.StrictMode>
  </BrowserRouter>
);
